import { useQuery } from '@apollo/client/react';
import { SubscriptionModel } from '../interfaces';
import { SubscriptionProduct, subscriptionProductNames } from '../interfaces.enums';
import { GET_SUBSCRIPTIONS } from '../subscriptions/subscriptions.graphql';
import { inReportOrder } from '../subscriptions/reportOrder';

export interface RenewalProduct {
  number: string;
  name: string;
  product?: SubscriptionProduct | null;
  level: number;
  selector: (x: RenewalInfo) => number | undefined;
}

export interface RenewalAmount {
  number: string;
  amount: number;
}

export interface RenewalInfo {
  id: string;
  licenseId: number;
  subscriptionOrderNumber: string;
  name: string;
  amounts?: RenewalAmount[];
  total: number;
}

export function amountOf(renewal: RenewalInfo, number: string): number | undefined {
  const amounts = renewal.amounts?.filter((x) => x.number === number) ?? [];
  return amounts.length ? amounts.reduce((sum, x) => sum + x.amount, 0) : undefined;
}

export function useRenewalProducts(): RenewalProduct[] | undefined {
  const { data } = useQuery<{ subscriptions: SubscriptionModel[] }>(GET_SUBSCRIPTIONS);
  return data ? renewalProducts(data.subscriptions) : undefined;
}

export function renewalProducts(subscriptions: SubscriptionModel[]): RenewalProduct[] {
  return inReportOrder(subscriptions)
    .filter((x) => x.subscription.number)
    .map(({ subscription, level }) => {
      const number = subscription.number!;
      return { number, name: subscription.name, product: subscription.product, level, selector: (x: RenewalInfo) => amountOf(x, number) };
    });
}

export function productName(product: SubscriptionProduct | null | undefined): string {
  return product ? subscriptionProductNames[product] : 'Uten produkt';
}
